import { useState, useEffect, useCallback } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const total = testimonials.length;

  const goTo = useCallback(
    (index: number) => {
      setCurrent(((index % total) + total) % total);
    },
    [total]
  );

  const next = useCallback(() => goTo(current + 1), [current, goTo]);
  const prev = useCallback(() => goTo(current - 1), [current, goTo]);

  useEffect(() => {
    if (!isAutoPlaying) return;
    const timer = setInterval(() => next(), 6000);
    return () => clearInterval(timer);
  }, [isAutoPlaying, next]);

  const t = testimonials[current];

  return (
    <section id="testimonials" className="py-20 md:py-28 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          <span className="inline-block text-dark-400 text-xs font-semibold uppercase tracking-widest mb-6">
            Recenzije
          </span>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-dark-900 leading-tight mb-16">
            Šta kažu naši klijenti
          </h2>

          <div className="relative bg-dark-900 rounded-3xl overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-5 min-h-[500px]">
              <div className="lg:col-span-2 relative overflow-hidden">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-full h-full object-cover object-center absolute inset-0"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-dark-900/80 to-transparent lg:bg-gradient-to-r lg:from-dark-900 lg:to-transparent"></div>
              </div>

              <div className="lg:col-span-3 flex flex-col justify-center p-8 md:p-12 lg:p-16 relative">
                <div className="text-accent-400 text-7xl leading-none mb-6 font-serif">
                  &ldquo;
                </div>

                <p className="text-lg sm:text-xl text-white/90 leading-relaxed mb-8">
                  {t.text}
                </p>

                <div className="mb-8">
                  <div className="font-bold text-white text-base">
                    {t.name}
                  </div>
                  <div className="text-white/50 text-sm">
                    {t.role}
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <button
                    onClick={() => {
                      prev();
                      setIsAutoPlaying(false);
                    }}
                    className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/70 hover:bg-white/10 hover:text-white transition-all cursor-pointer"
                  >
                    <i className="ri-arrow-left-line"></i>
                  </button>

                  <div className="flex items-center gap-2">
                    {testimonials.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          goTo(index);
                          setIsAutoPlaying(false);
                        }}
                        className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                          index === current
                            ? "bg-accent-400 w-6"
                            : "bg-white/20 hover:bg-white/40"
                        }`}
                      ></button>
                    ))}
                  </div>

                  <button
                    onClick={() => {
                      next();
                      setIsAutoPlaying(false);
                    }}
                    className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/70 hover:bg-white/10 hover:text-white transition-all cursor-pointer"
                  >
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}